import { axiosPost, axiosPut } from 'shared/api/axios'
import { AxiosError } from 'axios'
import { apiUrls } from 'consts'
import displayGenError from 'shared/utils/displayGenError'
import setFormValidationError from 'shared/utils/setFormValidationError'

interface submitFormProps {
  data: any
  setShowOverlay: Function
  id: string | undefined
  setError: Function
}

const submitForm = async (props: submitFormProps) => {
  let response: any = false

  const formData = {
    ...props.data,
    type: props.data?.type?.id
  }
  
  const catchFunc = (err: AxiosError) => {
    if (err.response!.status === 422) {
      const mappedAttributes: Map<string, string> = new Map()
      mappedAttributes.set('name', 'name')
      mappedAttributes.set('type', 'type')
      mappedAttributes.set('host', 'host')
      mappedAttributes.set('db', 'db')
      mappedAttributes.set('username', 'username')
      mappedAttributes.set('password_api', 'password_api')
      setFormValidationError(err, props.setError, mappedAttributes, 'name')
    } else {
      displayGenError({ setShowOverlay: props.setShowOverlay })
    }
  }

  if (props.id === undefined) {
    response = await axiosPost(apiUrls.connections, formData, catchFunc)
  } else {
    response = await axiosPut(apiUrls.connections + '/' + props.id, formData, catchFunc)
  }
  return response
}

export default submitForm
